import axios from "axios";
import { authUrl2 } from "../../api/Constants";

// AWS credentials must never be present in a browser bundle. The API verifies
// the vendor and issues a short-lived URL for one upload.
const uploadsUrl = `${authUrl2}/api/v1/vendor/uploads`;

const authHeaders = () => ({
  "access-token": localStorage.getItem("access_token"),
  client: localStorage.getItem("client"),
  uid: localStorage.getItem("uid"),
});

const extensionForContentType = (contentType) => {
  const extensions = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/svg+xml": "svg",
  };

  return extensions[contentType] || "bin";
};

const uploadableFile = (file) => {
  if (file instanceof File) return file;

  // react-image-file-resizer returns a Blob for resized images.
  if (file instanceof Blob) {
    const contentType = file.type || "application/octet-stream";
    return new File(
      [file],
      `upload-${Date.now()}.${extensionForContentType(contentType)}`,
      { type: contentType },
    );
  }

  throw new TypeError("A file is required for upload");
};

export const FileUploadPromise = async (file) => {
  const uploadFile = uploadableFile(file);
  const response = await axios.post(
    `${uploadsUrl}/presign`,
    {
      filename: uploadFile.name,
      content_type: uploadFile.type || "application/octet-stream",
      size: uploadFile.size,
    },
    { headers: authHeaders() },
  );
  const data = response.data?.data || response.data;
  const uploadUrl = data.upload_url || data.uploadUrl;

  if (!uploadUrl || !data.key || !data.location) {
    throw new Error("The upload endpoint returned an invalid presigned upload");
  }

  const upload = await axios.put(uploadUrl, uploadFile, {
    headers: {
      ...(data.headers || {}),
      "Content-Type": uploadFile.type || "application/octet-stream",
    },
  });

  return { status: upload.status, key: data.key, location: data.location };
};

export const FileDeletePromise = (key) =>
  axios.delete(uploadsUrl, {
    headers: authHeaders(),
    params: { key },
  });
